<template>
    <div>
        <div class="row">
            <div class="col">
                <tankcards-mutations-filter
                    :mutationTypes="mutationTypes"
                    @getTankCardMutations="getTankCardMutations"/>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col">
                <tankcards-mutations-table
                    ref="tankcardsTable"
                    :isLoaded="isLoaded"
                    :isLoading="isLoading"
                    :selectedDebtor="selectedDebtor"
                    :selectedCardNumber="selectedCardNumber"
                    :selectedMutationTypes="selectedMutationTypes"
                    :startDate="startDate"
                    :endDate="endDate"
                    @updateLoaded="updateLoaded"
                />
            </div>
        </div>
    </div>
</template>

<script>


export default {
    props: {
        mutationTypes: Array
    },
    data() {
        return {
            isLoading: false,
            isLoaded: true,
            messages: [],
            postSuccessful: null,
            startDate: null,
            endDate: null,
            selectedMutationTypes: [],
            selectedCardNumber: '',
            selectedDebtor: '',
        };
    },
    methods: {
        updateLoaded: function (status) {
            this.isLoading = status;
        },
        getTankCardMutations: function ({
                                            selectedCardNumber,
                                            selectedDebtor,
                                            startDate,
                                            endDate,
                                            selectedMutationTypes
                                        }) {
            this.selectedCardNumber = selectedCardNumber;
            this.selectedMutationTypes = selectedMutationTypes;
            this.selectedDebtor = selectedDebtor;
            this.startDate = startDate;
            this.endDate = endDate;
            this.isLoading = true;
            this.$nextTick(() => {
                this.$refs.tankcardsTable.reloadTable()
            })
        },
    }

}
</script>
